export enum Permission {
    BUPROFILE = "UI.AUTH.BUPROFILE",
    LOGIN = "LOGIN",
    USER = "UI.ADMIN.USER",
    USERGROUP = "UI.ADMIN.USERGROUP",
    USERSETTING = "UI.ADMIN.USERSETTING",
    CHARGE_PROCESSING = "UI.CHAR.CHARGEPROCESSING",
    CHANGE_KEY_DATA = "UI.CHAR.CHANKEYDATAMAIN",
    MANUAL_CHARGE = "UI.CHAR.MANUALCHARGE",
    CHARGE_DEATIL_MAINTENANCE = "UI.CHAR.CHARGEDETAILMAINTENANCE",
    MANUAL_CHARGE_DETAIL = "UI.CHAR.MANUALCHARGEDETAIL",
    NON_OPS_CHARGE = "UI.CHAR.NONOPSCHARGE",
    NON_OPS_CHARGE_DETAIL = "UI.CHAR.NONOPSCHARGEDETAIL",
    CHARGE_CONFIRMED_MAIN = "UI.CHAR.CHARGECONFIRMED",
    CREDIT_NOTE = "UI.CHAR.CREDITNOTE",
    CREDIT_NOTE_DETAIL = "UI.CHAR.CREDITNOTEDETAIL",
    REQUISITION_FORM = "UI.CHAR.REQUISITIONFORM",
    RECAL_PROCESSGEN = "UI.CHAR.RECALPROCESSGEN",
    EMPTY_POOL_STORAGE_GEN = "UI.CHAR.EMPTYPOOLSTORAGEGEN",
    DOCUMENT_APPROVAL = "UI.DOC.DOCUMENTAPPROVAL",
    DOCUMENT_PREVIEW = "UI.CHAR.INVOICE",
    DOCUMENT_PREVIEW_SL = "UI.CHAR.INVOICE.PREVIEW.SL",
    DOCUMENT_PREVIEW_CC = "UI.CHAR.INVOICE.PREVIEW.CC",
    DOCUMENT_PREVIEW_DISAPPROVE = "UI.CHAR.INVOICE.DISAPPROVE",
    DOCUMENT_PREVIEW_APPROVE = "UI.CHAR.INVOICE.APPROVE",
    DOCUMENT_PREVIEW_DETAIL = "UI.CHAR.INVOICEDETAIL",
    SUPPLEMENTARY_INVOICE = "UI.CHAR.SUPPLEMENTARYINVOICE",
    SUPPLEMENTARY_INVOICE_DETAIL = "UI.CHAR.SUPPLEMENTARYINVOICEDETAIL",
    DOCUMENT_EDI_MONITORING = "UI.DOC.EDIMONITORING",
    DOCUMENT_ENQUIRY_DETAIL = "UI.DOC.DOCUMENTENQUIRYDETAIL",
    PROPOSAL_ENQUIRY_DETAIL = "UI.PROP.PROPOSALENQUIRYDETAIL",
    PROPOSAL_ENQUIRY_ACTIVATE = "UI.PROP.PROPOSALENQUIRY.ACTIVATE",
    PROPOSAL_ENQUIRY_DEACTIVATE = "UI.PROP.PROPOSALENQUIRY.DEACTIVATE",
    STANDARD_PROPOSAL_MAINTENANCE = "UI.AGREE.STANDARDPROPOSALMAIN",
    STANDARD_PROPOSAL_REJECT = "UI.AGREE.STANDARDPROPOSAL.REJECT",
    STANDARD_PROPOSAL_APPROVE = "UI.AGREE.STANDARDPROPOSAL.APPROVE",
    STANDARD_PROPOSAL_UNCONFIRM = "UI.AGREE.STANDARDPROPOSAL.UNCONFIRM",
    STANDARD_PROPOSAL_DETAIL_MAINTENANCE = "UI.AGREE.STANDARDPROPOSALDETAILMAIN",
    GENERAL_PROPOSAL_MAINTENANCE = "UI.AGREE.GENERALPROPOSALMAIN",
    GENERAL_PROPOSAL_REJECT = "UI.AGREE.GENERALPROPOSAL.REJECT",
    GENERAL_PROPOSAL_APPROVE = "UI.AGREE.GENERALPROPOSAL.APPROVE",
    GENERAL_PROPOSAL_UNCONFIRM = "UI.AGREE.GENERALPROPOSAL.UNCONFIRM",
    GENERAL_PROPOSAL_DETAIL_MAINTENANCE = "UI.AGREE.GENERALPROPOSALDETAILMAIN",
    TARIFF_NATURE_MAINTENANCE = "UI.CODE.TARIFFNATUREMAIN",
    TARIFF_TYPE_MAINTENANCE = "UI.CODE.TARIFFTYPEMAIN",
    TARIFF_COMPONENT_MAINTENANCE = "UI.TARIFF.TARIFFCOMPONENTMAIN",
    TARIFF_CODE_MAINTENANCE = "UI.TARIFF.TARIFFCODEMAIN",
    TARIFF_CODE_BY_COMPANY_MAINTENANCE = "UI.TARIFF.TARIFFCODEBYCOMPANYMAIN",
    COMPANY_MAINTENANCE = "UI.COMP.COMPANYMAINTENANCE",
    COMPANY_DETAIL_MAINTENANCE = "UI.COMP.COMPANYDETAILMAINTENANCE",
    BILL_TO_COMPANY_MAPPING_MAINTENANCE = "UI.CHAR.BILLTOCOMPANYMAPPINGMAINTENANCE",
    CHARGE_ON_COMPANY_MAPPING_MAINTENANCE = "UI.CHAR.CHARGEONCOMPANYMAPPINGMAINTENANCE",
    BILLING_TYPE_MAPPING_MAINTENANCE = "UI.CHAR.BILLINGTYPEMAPPINGMAINTENANCE",
    EQUIPMENT_CODE_IND_MAPPING_MAINTENANCE = "UI.CHAR.EQUIPMENTCODEINDMAPPINGMAINTENANCE",
    MASTER_CODE_MAINTENANCE = "UI.CODE.MASTERCODEMAINTENANCE",
    SPECIAL_HANDLING_IND_MAPPING_MAINTENANCE = "UI.CHAR.SPECIALHANDLINGINDMAPPINGMAINTENANCE",
    BILLING_CYCLE_MAINTENANCE = "UI.CODE.BILLINGCYCLEMAINTENANCE",
    CHARGE_TYPE_MAINTENANCE = "UI.CODE.CHARGETYPEMAINTENANCE",
    SHIFT_MAINTENANCE = "UI.CODE.SHIFTMAINTENANCE",
    GROUP_MAINTENANCE = "UI.CODE.GROUPMAINTENANCE",
    CALENDAR_EVENT_MAINTENANCE = "UI.CODE.CALENDAREVENTMAINTENANCE",
    STAFF_VSL_CODE_MAINTENANCE = "UI.CODE.STAFFVSLCODEMAINTENANCE",
    COMMON_ACCOUNT_MAINTENANCE = "UI.CHAR.COMMONACCOUNTMAINTENANCE",
    CHARGE_QTY_ADJ_MAINTENANCE = "UI.CHAR.CHARGEQTYADJMAINTENANCE",
    CHARGE_CRITERIA_MAINTENANCE = "UI.CHARSET.CHARCRITMAIN",
    GENERAL_CHARGE_CRITERIA_MAINTENANCE = "UI.CHARSET.GENECHARGENECRITMAIN",
    CHARGE_EXCLMAIN_CRITERIA_MAINTENANCE = "UI.CHARSET.CHAREXCLMAIN",
    EMPTY_POOL_EXCL_CRITERIA_MAINTENANCE = "UI.CHARSET.EMPTPOOLEXCLMAIN",
    MARSHALLING_TYPE_EXCL_CRITERIA_MAINTENANCE = "UI.CHARSET.MARSTYPEEXCLCRITMAIN",
    COMPANY_FSP_REJECT = "UI.COMP.COMPANYFSP.REJECT",
    COMPANY_FSP_APPROVE = "UI.COMP.COMPANYFSP.APPROVE",
    COMPANY_EMPTY_POOL_REJECT = "UI.COMP.COMPANYEMPTYPOOL.REJECT",
    COMPANY_EMPTY_POOL_APPROVE = "UI.COMP.COMPANYFSPEMPTYPOOL.APPROVE",
    COMPANY_CHARGE_SUPPLE_TERMS_REJECT = "UI.COMP.COMPANYCHARGESUPPLETERMS.REJECT",
    COMPANY_CHARGE_SUPPLE_TERMS_APPROVE = "UI.COMP.COMPANYCHARGESUPPLETERMS.APPROVE",
    DOCUMENT_SEPARATION_CRITERIA_MAINTENANCE = "UI.DOCSET.DOCUSEPACRITMAIN",
    DOCUMENT_GROUPING_CRITERIA_MAINTENANCE = "UI.DOCSET.DOCUGROUCRITMAIN",
    TARIFF_MAPPING_MAINTENANCE = "UI.CHAR.TARIFFMAPPINGMAINTENANCE",
    TRANSACTION_TYPE_SETTING_MAINTENANCE = "UI.DOCSET.TRANSTYPESETTINGMAIN",
    CURRENCY_EXCHANGE_MAINTENANCE = "UI.DOCSET.EXCHANGERATEMAIN",
    PRINT_QUEUE_MAINTENANCE = "UI.DOCSET.PRINTQUEUEMAIN",
    EMAIL_TEMPLATE_MAINTENANCE = "UI.DOCSET.EMAILTEMPLATEMAIN",
    EDI_ITEM_CODE_MAPPING_MAINTENANCE = "UI.EDISET.EDIITEMCODEMAIN",
    COST_CENTER_CODE_MAPPING_MAINTENANCE = "UI.EDISET.COSTCENTERCODEMAIN",
    TARIFF_COA_MAPPING_MAINTENANCE = "UI.CHAR.TARIFFCOAMAPPINGMAINTENANCE",
    ACTIVITY_LOG_MAINTENANCE = "UI.SYSTEM.ACTIVITYLOG",
    DISCOUNT_MAPPING_MAINTENANCE = "UI.CHAR.DISCOUNTMAPPINGMAINTENANCE",
    TAX_MAPPING_MAINTENANCE = "UI.CHAR.TAXMAPPINGMAINTENANCE",
    CUSTOMER_ENQUIRY_MAINTENANCE = "UI.COMP.CUSTOMERENQUIRYMAINTENANCE",
    PORT_MAINTENANCE = "UI.CODE.PORTMAINTENANCE",
    MASTER_HOLD_MAINTENANCE = "UI.DOCSET.MASTERHOLDMAINTENANCE",
    DOCUMENT_ISSUANCE_MAINTENANCE = "UI.DOCSET.DOCUMENTISSUANCEMAINTENANCE",
    PARAMETER_MAINTENANCE = "UI.SUPPORT.PARAMETERMAINTENANCE",
    INTERNAL_CORRECTION_MAINTENANCE = "UI.REPO.INTECORRMAIN",
    CHARGE_DATA_ENQUIRY = "UI.CHAR.CHARGEDATAENQUIRY",
    DOCUMENT_ENQUIRY = "UI.DOC.DOCUMENTENQUIRY",
    PROPOSAL_ENQUIRY = "UI.PROP.PROPOSALENQUIRY",
    AUDIT_TRAIL_REPORT_MAINTENANCE = "UI.REPO.AUDITTRAILREPORTMAINTENANCE",
    GENERAL_REPORT_MAINTENANCE = "UI.REPO.GENERALREPORTMAINTENANCE",
    FINANCIAL_REPORT_MAINTENANCE = "UI.REPO.FINANCIALREPORTMAINTENANCE",
    REVENUE_RECONCILIATION_REPORT_MAINTENANCE = "UI.REPO.REVENUERECONCILIATIONREPORTMAINTENANCE",
    MONTH_END_CLOSURE_MAINTENANCE = "UI.REPO.MONTHENDCLOSUREMAINTENANCE",
    AUDIT_LOG_MAINTENANCE = "UI.SYSTEM.AUDITLOG",
    QUOTATION_SETTING_MAINTENANCE = "UI.CHAR.QUOTATIONSETTINGMAINTENANCE",
    REQUEST_SERVICE_CODE_MAINTENANCE = "UI.CODE.REQUESTSERVICECODEMAIN",
    MASTER_FSP_MAINTENANCE = "UI.MAST.MASTERFSPMAINTENANCE",
    MASTER_FSP_SUBMIT = "UI.MAST.MASTERFSPMAINTENANCE.SUBMIT",
    MASTER_FSP_REJECT = "UI.MAST.MASTERFSPMAINTENANCE.REJECT",
    MASTER_FSP_APPROVE = "UI.MAST.MASTERFSPMAINTENANCE.APPROVE",
    MOVEMENT_PATTERN_MAINTENANCE = "UI.CHAR.MOVEMENTPATTERNMAINTENANCE",
    RESEND_RELEASE_PAYMENT_HOLD_MAINTENANCE = "UI.DOC.RESENDRELEASEPAYMENTHOLD",
    PARTICIPATION_RATE_MAINTENANCE = "UI.CHAR.PARTICIPATIONRATEMAIN",
    EBIS_INTERFACE_MONITORING_MAINTENANCE = "UI.INTERFACE.EBISINTERFACEMONITORINGMAIN",
    EBIS_INTERFACE_MONITORING_DETAIL_MAINTENANCE = "UI.INTERFACE.EBISINTERFACEMONITORINGDETAILMAIN",
    BANK_INTERFACE_MONITORING_MAINTENANCE = "UI.INTERFACE.BANKINTERFACEMONITORINGMAIN",
    DIRECT_DATA_INPUT_MAINTENANCE = "UI.CHARGE.DIRECTDATAINPUTMAIN",
    TRANSFER_OF_CHARGE_MAINTENANCE = "UI.CHARGE.TRANSFEROFCHARGEMAIN",
    ADHOC_HOLD_OF_CONTAINER_MAINTENANCE = "UI.CHARGE.ADHOCHOLDOFCONTAINERMAINTENANCE",
    RESUME_SG_CHARGE_MAINTENANCE = "UI.CHARGE.RESUMESGCHARGEMAINTENANCE",
    EXCHANGE_RATE_REF_DATE_MAPPING_MAINTENANCE = "UI.DOCSET.EXCHANGERATEREFERENCEDATEMAIN",
    COUNTER_CUSTOMER_CHARGE_MAINTENANCE = "UI.CHARGE.COUNTERCHARDETAILS",
    COUNTER_CUSTOMER_CHARGE_MAINTENANCE_MARKMT = "UI.CHARGE.COUNTERCHARDETAILS.MARKMT",
    COUNTER_CUSTOMER_CHARGE_MAINTENANCE_DELETE = "UI.CHARGE.COUNTERCHARDETAILSDELETE",
    COUNTER_CUSTOMER_CHARGE_MAINTENANCE_ADJUSTMENT = "UI.CHARGE.COUNTERCHARDETAILS.ADJUSTMENT",
    BANKER_MAINTENANCE = "UI.CODE.BANKERMAINTENANCE",
    LET_PASS_ACCOUNT_MAINTENANCE = "UI.COLL.LETPASSACCOUNTMAINTENANCE",
    LET_PASS_ACCOUNT_OPEN = "UI.COLL.LETPASSACCOUNTMAINTENANCE.ACCOUNT.OPEN",
    LET_PASS_ACCOUNT_CLOSURE = "UI.COLL.LETPASSACCOUNTMAINTENANCE.ACCOUNT.CLOSURE",
    PROPOSAL_COPY_FOR_RECAL_MAINTENANCE = "UI.RECAL.PROPOSALCOPYFORRECALMAIN",
    RECAL_PROPOSAL_SET_MAINTENANCE = "UI.CHAR.RECALPROPOSALSET",
    PAYMENT_DETAILS_MAINTENANCE = "UI.COLL.PAYMENTDETAILSMAINTENANCE",
    CHARGE_WAIVER = "UI.CHARGE.WAIVERAPPLICATION",
    CHARGE_WAIVER_REJECT = "UI.CHARGE.WAIVERAPPLICATION.REJECT",
    CHARGE_WAIVER_APPROVE = "UI.CHARGE.WAIVERAPPLICATION.APPROVE",
    REFUND_MAINTENANCE = "UI.COLL.REFUNDMAINTENANCE",
    REFUND_MAINTENANCE_APPROVE = "UI.COLL.REFUNDMAINTENANCE.APPROVE",
    REFUND_MAINTENANCE_ISSUE = "UI.COLL.REFUNDMAINTENANCE.ISSUE",
    REFUND_MAINTENANCE_REJECT = "UI.COLL.REFUNDMAINTENANCE.REJECT",
    REFUND_MAINTENANCE_PROCESS = "UI.COLL.REFUNDMAINTENANCE.PROCESS",
    REFUND_MAINTENANCE_VERIFY = "UI.COLL.REFUNDMAINTENANCE.VERIFY",
    CHARGE_WAIVER_REGISTRATION_MAINTENANCE = "UI.CHARGE.CHARGEWAIVERREGISTRATIONMAINTENANCE",
    ASSIGN_INVOICE_CRITERIA_MAINTENANCE = "UI.RECAL.ASSIGNINVOICECRITERIAMAIN",
    GENERAL_CSV_REPORT_MAINTENANCE = "UI.REPO.GENERALCSVREPORTMAINTENANCE",
    ESTIMATED_UNBILL_FIGURE_MAINTENANCE = "UI.REPO.ESTIMATEDUNBILLFIGUREMAINTENANCE",
}
